import { render, staticRenderFns } from "./CorrespondenceItemCreateConfigurator.vue?vue&type=template&id=122e8119"
import script from "./CorrespondenceItemCreateConfigurator.vue?vue&type=script&lang=js"
export * from "./CorrespondenceItemCreateConfigurator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports